import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { isAdminHost } from './lib/adminHost'
import AdminApp from './AdminApp'
import RedirectToAdminLogin from './components/admin/RedirectToAdminLogin'
import LandingLayout from './components/LandingLayout'
import { LandingPage, AboutPage, GivePage, NewsPage } from './components/landing'
import ChapterRouter from './components/landing/chapters/ChapterRouter'
import { FeatureFlagsProvider, useFeatureFlags } from './context/FeatureFlagsProvider'
import ChapterIntakeUploadRedirect from './pages/ChapterIntakeUploadRedirect'
import NotFound from './pages/NotFound'

function LegacyChapterRedirect() {
  const { slug } = useParams()
  if (!slug) return <Navigate to="/" replace />
  return <Navigate to={`/${slug}`} replace />
}

function PublicApp() {
  const { flags } = useFeatureFlags()

  return (
    <Routes>
      <Route element={<LandingLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="about" element={<AboutPage />} />
        {flags.announcements && <Route path="news" element={<NewsPage />} />}
        <Route path="give" element={<GivePage />} />
        <Route path="chapter-intake/upload" element={<ChapterIntakeUploadRedirect />} />
        <Route path="chapter-intake" element={<ChapterIntakeUploadRedirect />} />
        <Route path="chapters/:slug" element={<LegacyChapterRedirect />} />
        <Route path="limerick" element={<Navigate to="/kerry" replace />} />
        <Route path=":slug" element={<ChapterRouter />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="upcoming-events" element={<Navigate to="/#upcoming-programs" replace />} />
      <Route path="login" element={<RedirectToAdminLogin />} />
    </Routes>
  )
}

function App() {
  return (
    <FeatureFlagsProvider>
      {isAdminHost() ? <AdminApp /> : <PublicApp />}
    </FeatureFlagsProvider>
  )
}

export default App
